import { createFileRoute } from '@tanstack/react-router';
import { WorkflowsPage } from '../../features/settings/components/workflows-page.js';

export const Route = createFileRoute('/admin/workflows')({ component: WorkflowsPage });
